import { createBrowserHistory } from 'history';
import serverBrowserHistoryStub from './serverBrowserHistoryStub';

// This is the mutable history variable by design
// It could be overriden on yoda-app-shell level during microsite bootstrap just to have basename property working
let browserHistory; // eslint-disable-line

function setBrowserHistory(options) {
    /* istanbul ignore next */
    if (__SERVER__) {
        browserHistory = serverBrowserHistoryStub;
    } else {
        browserHistory = options ? createBrowserHistory(options) : createBrowserHistory();
    }
}

setBrowserHistory();

export const overrideBrowserHistory = (options) => {
    setBrowserHistory(options);
};
export default () => browserHistory;
